module.exports = __webpack_public_path__ + "static/img/bg20.e4e28d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg20.jpg
// module id = 5Tc/
// module chunks = 1